'use strict';

export const WEATHER_NETWORK_HELP_ARTICLE = 'WEATHER_NETWORK_HELP_ARTICLE';
export const VRM_OVERRIDE_HELP_ARTICLE = 'VRM_OVERRIDE_HELP_ARTICLE';
export const INNER_BOUNDARIES_HELP_ARTICLE = 'INNER_BOUNDARIES_HELP_ARTICLE';
export const EDIT_FIELD_BOUNDARIES_HELP_ARTICLE = 'EDIT_FIELD_BOUNDARIES_HELP_ARTICLE';
export const NULL_ZONES_HELP_ARTICLE = 'NULL_ZONES_HELP_ARTICLE';
export const SPLIT_FIELD_HELP_ARTICLE = 'SPLIT_FIELD_HELP_ARTICLE';
export const MERGE_FIELDS_HELP_ARTICLE = 'MERGE_FIELDS_HELP_ARTICLE';
/* ============== //
 ||     TYPES     ||
 // ============== */

const SET_HELP_ARTICLES_SEEN = 'fieldsense/Help/SET_HELP_ARTICLES_SEEN';
const SHOW_HELP_DIALOG = 'fieldsense/Help/SHOW_HELP_DIALOG';
const HIDE_HELP_DIALOG = 'fieldsense/Help/HIDE_HELP_DIALOG';

/* ============== //
 ||    ACTIONS    ||
 // ============== */

export function showHelpDialog(feature) {
  return {
    type: SHOW_HELP_DIALOG,
    payload: feature,
  };
}

export function hideHelpDialog() {
  return {
    type: HIDE_HELP_DIALOG,
  };
}

export function setHelpArticleSeen(articleID) {
  return {
    type: SET_HELP_ARTICLES_SEEN,
    payload: articleID,
  };
}

/* ============== //
 ||    REDUCER    ||
 // ============== */

const initState = {
  currentDialog: null,
  seenHelpArticleIDs: [],
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case SHOW_HELP_DIALOG: {
      state = { ...state, currentDialog: action.payload };
      break;
    }

    case HIDE_HELP_DIALOG: {
      state = { ...state, currentDialog: null };
      break;
    }

    case SET_HELP_ARTICLES_SEEN: {
      const id = action.payload;

      state = { ...state, seenHelpArticleIDs: [...state.seenHelpArticleIDs, id] };
      break;
    }

    default:
      break;
  }

  return state;
}
